;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ["leaderboardservices", "selected_merchant"],
  data: function data() {
    return {
      services: [],
      allowed_accounts: null,
      page_number: 1,
      page_size: 10,
      total_pages: null
    };
  },
  mounted: function mounted() {
    this.get_accounts(this.page_number);
  },

  computed: {
    merchant_accounts: function merchant_accounts() {
      return this.allowed_accounts;
    },
    pages: function pages() {
      return this.total_pages;
    }
  },
  watch: {
    leaderboardservices: function leaderboardservices(val) {
      this.services = val;
    }
  },
  methods: {
    get_accounts: function get_accounts(page_number) {
      var _this = this;

      Vue.axios.get("/api/dashboard/admin/accounts", {
        params: {
          page: page_number,
          page_size: this.page_size,
          merchant_id: this.selected_merchant ? this.selected_merchant : null
        }
      }).then(function (response) {
        _this.allowed_accounts = response.data;
        _this.total_pages = response.data.total_pages;
      }).catch(function (error) {
        _this.loading = false;
      }).then(function () {
        _this.loading = false;
      });
    },
    nextPage: function nextPage() {
      if (this.page_number && this.page_number < this.pages) {
        this.get_accounts(this.page_number + 1);
        this.page_number += 1;
      }
    },
    prevPage: function prevPage() {
      if (this.page_number && this.page_number > 1) {
        this.get_accounts(this.page_number - 1);
        this.page_number -= 1;
      }
    },
    change_page_size: function change_page_size() {
      this.get_accounts(this.page_number);
    },

    to_fixed: function to_fixed(val) {
      return (Math.round(val * 100) / 100).toFixed(2);
    },
    formatNumber: function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    to_human: function to_human(x) {
      if (x == null) return 0;
      var n = this.to_fixed(x);
      return this.formatNumber(n.toLocaleString());
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-nowrap card-table"},[_vm._m(1),_vm._v(" "),(_vm.allowed_accounts != null)?_c('tbody',{key:_vm.page_number},_vm._l((_vm.merchant_accounts.entries),function(item,index){return _c('tr',{key:index},[_c('td',[_c('strong',[_vm._v(_vm._s(item.id))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s(item.currency)+" "+_vm._s(_vm.to_human(item.balance))+"\n                ")])])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"card-footer pb-0 mb-0 d-flex justify-content-between col-sm-2"},[_c('nav',{attrs:{"aria-label":"Page navigation example"}},[_c('ul',{staticClass:"pagination"},[(_vm.page_number > 1)?_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.prevPage()}}},[_vm._v("Previous")])]):_vm._e(),_vm._v(" "),(_vm.page_number < _vm.pages)?_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.nextPage()}}},[_vm._v("Next")])]):_vm._e()])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"float-right col-sm-2 mx-100"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.page_size),expression:"page_size"}],staticClass:"form-control input-sm",attrs:{"id":"page_size","type":"text"},domProps:{"value":(_vm.page_size)},on:{"input":function($event){if($event.target.composing){ return; }_vm.page_size=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.change_page_size(_vm.page_number)}}},[_vm._v("\n                    Submit\n                  ")])])])])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-8 col-md-6"},[_c('br'),_vm._v(" "),_c('h4',[_vm._v("Merchant Accounts")]),_vm._v(" "),_c('p',{staticClass:"subtitle"},[_vm._v("List of Merchant Accounts")])])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"width":"100"}},[_vm._v("Account ID")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Account Type")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"150"}},[_vm._v("Account Name")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"200"}},[_vm._v("Current Balance")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"text-center"})])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d0ed3c38", __vue__options__)
  } else {
    hotAPI.reload("data-v-d0ed3c38", __vue__options__)
  }
})()}